import { z } from 'zod'
import { LeadSourceType } from '~/@types/graphql-police'

export const contactUsFormSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  company: z.string().optional(),
  email: z.string().email(),
  phone: z.string().optional(),
  message: z.string().min(1),
  leadSource: z.enum([
    LeadSourceType.RecommendationOfARelative,
    LeadSourceType.Doctor,
    LeadSourceType.SocialNetworks,
    LeadSourceType.Press,
    LeadSourceType.SearchEngine,
    LeadSourceType.Podcast,
    LeadSourceType.Event,
    LeadSourceType.Other
  ]),
  leadSourceComment: z.string().optional(),
  isBrochureRequested: z.boolean().optional()
})

export type ContactUsFormValues = z.infer<typeof contactUsFormSchema>
